export default __webpack_public_path__ + "static/media/Children1.d817283d.jpg";